// import React from "react";
import PropTypes from "prop-types";

export default function Feedback({ title, desc }) {
  return (
    <section className="easeir_jh">
      <div className="container">
        {title ? (
          <div className="pos_tile">
            <h1 className={desc ? "mb-3" : ""}>{title}</h1>
          </div>
        ) : (
          ""
        )}
        {desc ? (
          <div className="pos_tile">
            <p>{desc}</p>
          </div>
        ) : (
          ""
        )}
        <div className="feedCard">
          <div className="row align-items-center">
            <div className="col-lg-6  position-relative">
              <div
                className="videoPlayer1"
                onClick={() =>
                  window.open("https://www.youtube.com/shorts/AkL8Bk4DDDA")
                }
              >
                <video
                  playsInline
                  autoPlay
                  muted
                  loop
                  width="100%"
                  className=""
                >
                  <source
                    src={"https://fusionbucket.co.uk/FMB/homepage/feedback.webm"}
                    // src={"/assets/feedback.webm"}
                    type="video/webm"
                  ></source>
                </video>


                <div className="position-absolute top-50 start-50 translate-middle">
                  <img loading="lazy" alt="fusion" src="/assets/img/play.svg" />
                </div>
                <div className="vid_tex">
                  <p className="mb-0 fw-bold text-light">Birmingham</p>
                  <small className="text-light">City in England</small>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mt-lg-0 mt-3 text-start">
              <div>
                <h4 className="mb-3 fw-bold">
                  What makes Fusion the favorite retail POS for businesses?
                </h4>
                <p className="text-dark">
                  Witness how Fusion streamlines business operations, enhances
                  customer service, and drives profitability. Hear the firsthand
                  experiences of our customers and discover how Fusion can
                  transform your business, too.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

Feedback.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
};
